var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import componentsMapping from "./components.js";
function EciSaasUIResolver(options = {}) {
  const {
    debug = !1,
    packageName = "@eci-saas/ui",
    excludeComponents = [],
    includeComponents,
    resolveIcons = !0,
    resolveComponents = !0,
    resolveDirectives = !0,
    usePreciseImports = !0
  } = options;
  return {
    type: "component",
    resolve: /* @__PURE__ */ __name((name) => {
      if (debug && console.log(`[EciSaasUIResolver] 解析 ${name}`), excludeComponents.includes(name) || includeComponents && includeComponents.length > 0 && !includeComponents.includes(name))
        return;
      const componentInfo = componentsMapping.all[name];
      if (!componentInfo) {
        debug && console.log(`[EciSaasUIResolver] 未找到组件: ${name}`);
        return;
      }
      if (debug && console.log(`[EciSaasUIResolver] 组件信息: ${JSON.stringify(componentInfo)}`), !(componentInfo.type === "component" && !resolveComponents) && !(componentInfo.type === "icon" && !resolveIcons) && !(componentInfo.type === "directive" && !resolveDirectives))
        return debug && console.log(`[EciSaasUIResolver] 解析 ${componentInfo.type}: ${name} 从 ${componentInfo.from}`), usePreciseImports ? componentInfo.type === "icon" ? {
          from: componentInfo.from
        } : {
          name: componentInfo.name,
          from: componentInfo.from
        } : {
          name: componentInfo.name,
          from: packageName
        };
    }, "resolve")
  };
}
__name(EciSaasUIResolver, "EciSaasUIResolver");
function EciSaasUIResolverWithOptions(options = {}) {
  return EciSaasUIResolver(options);
}
__name(EciSaasUIResolverWithOptions, "EciSaasUIResolverWithOptions");
function getUIComponentNames() {
  return Object.keys(componentsMapping.all);
}
__name(getUIComponentNames, "getUIComponentNames");
function getComponentStats() {
  return componentsMapping.stats;
}
__name(getComponentStats, "getComponentStats");
function getComponentsByType(type) {
  const targetMap = type === "component" ? componentsMapping.components : type === "icon" ? componentsMapping.icons : componentsMapping.directives;
  return Object.values(targetMap);
}
__name(getComponentsByType, "getComponentsByType");
export {
  EciSaasUIResolver,
  EciSaasUIResolverWithOptions,
  EciSaasUIResolver as default,
  getComponentStats,
  getComponentsByType,
  getUIComponentNames
};
//# sourceMappingURL=index.js.map
